import type { ISessionPort } from '@subscriptions/application/ports';

/**
 * Use case for reading the organization of the current store; null when there is no store.
 *
 * @param port - Session port
 * @returns Use case executor
 */
export const getCurrentOrganizationUuidUseCase = (port: ISessionPort) => {
  const execute = (): string | null => port.getOrganizationUuid();

  return { execute };
};

export type GetCurrentOrganizationUuid = ReturnType<typeof getCurrentOrganizationUuidUseCase>;
